import { useTimeoutPoll } from '@vueuse/core';
import { MaintenanceEnum, PcPageEnum } from '@mcex/constants';
import { Router } from 'vue-router';
import dayjs from 'dayjs';
import { notification } from 'ant-design-vue';
import DOMPurify from 'dompurify';
import { useI18n } from '@mcex/locale';

const MAINTENANCE_TIME = 30 * 60 * 1000; // 30分钟
export const useMaintenance = (router: Router, useAppStoreWithOut) => {
  const { t } = useI18n();
  // 1、定时查询系统维护状态
  // 2、系统将要维护时，弹出提示框
  // 3、系统维护时，拦截路由，跳转到维护页面
  // 4、系统维护完成后，取消路由拦截，刷新页面
  // 1、定时查询机制
  // 1.1 进入系统后立即查询
  // 1.2 随后正常情况下每30分钟查询一次
  // 1.3 当系统将要维护时，计算维护开始时间，延时进行查询
  let timer: Nullable<NodeJS.Timeout> = null;
  const updateMaintenance = async () => {
    const appStore = useAppStoreWithOut();
    const res = await appStore.fetchSystemInfo();
    console.log('🚀 ~ file: useMaintenance.tsx:22 ~ updateMaintenance ~ res:', res);
    timer && clearTimeout(timer);
    // 将要维护
    if (res.status === MaintenanceEnum.WILL_MAINTENANCE && dayjs().isBefore(dayjs(res.startTime))) {
      // 重置轮询
      isActive && pause();
      // 获取当前路由
      let showTip = true;
      const currentRoute = router.currentRoute.value;
      const path = currentRoute.path;
      const maintenancePages = res.promptPages;
      if (maintenancePages && maintenancePages.length > 0) {
        showTip = maintenancePages.some((item) => {
          // 是否为正则表达式字符串
          if (item.startsWith('/') && item.endsWith('/')) {
            const reg = new RegExp(item.slice(1, -1));
            return reg.test(path);
          }
          return item === path;
        });
      }
      // 替换${startTime}和${endTime}
      let content =
        res.content ??
        '系统将于${startTime}至${endTime}进行维护，届时将无法正常使用，请及时保存数据并退出系统！';
      content =
        content === ''
          ? '系统将于${startTime}至${endTime}进行维护，届时将无法正常使用，请及时保存数据并退出系统！'
          : content;
      const description = content
        ?.replace(/\${startTime}/g, dayjs(res.startTime).format('YYYY-MM-DD HH:mm'))
        .replace(/\${endTime}/g, dayjs(res.endTime).format('YYYY-MM-DD HH:mm'));

      const renderDescription = () => {
        const cleanHtml = DOMPurify.sanitize(description);
        return <div v-html={cleanHtml}></div>;
      };
      // 1秒后提示
      showTip &&
        setTimeout(() => {
          notification.warning({
            duration: null,
            placement: 'bottomRight',
            message: t('common.prompt'),
            description: renderDescription,
            onClose: () => {
              console.log('关闭提示');
            },
          });
        }, 1000);
      // 开始时间-当前时间
      const startTime = res.startTime;
      const now = new Date().getTime();
      const delay = startTime - now;
      // 延时查询
      timer = setTimeout(() => {
        updateMaintenance();
      }, delay);
      return;
    }
    // 维护中
    if (
      (res.status === MaintenanceEnum.IN_PROGRESS || res.inMaintenance) &&
      dayjs().isBefore(dayjs(res.endTime))
    ) {
      isActive && pause();
      // 设置维护状态
      appStore.setMaintenance(true);
      // 跳转到维护页面
      router.push(PcPageEnum.SYS_UPDATE);
      // 结束时间-当前时间
      const endTime = res.endTime;
      const now = new Date().getTime();
      const delay = endTime - now;
      // 延时查询
      timer = setTimeout(() => {
        updateMaintenance();
      }, delay);
      return;
    }
    if (res.status === MaintenanceEnum.FINISHED) {
      if (!appStore.getMaintenance) {
        return;
      }
      // 取消维护状态
      appStore.setMaintenance(false);
      // 跳转到首页
      router.push(PcPageEnum.BASE_HOME);
    }
  };
  const { isActive, pause, resume } = useTimeoutPoll(updateMaintenance, MAINTENANCE_TIME, {
    immediate: false,
  });

  // 路由变化时，重新开始计时
  router.afterEach((to, from) => {
    if (to.fullPath === from.fullPath) {
      return;
    }
    resume();
  });
};
